import {queryOptions, useQuery} from '@tanstack/react-query';

import api, {type SiteParams} from '@/api/pageService';

export const pageServiceSiteQuery = (params: SiteParams) => {
  return queryOptions({
    queryKey: ['page-service', 'site', params],
    queryFn: async ({signal}) => {
      const response = await api.site(params, {signal});
      if (response.status !== 200) {
        throw new Error('Failed to fetch site from page-service');
      }
      // check for errors AND redirects
      if ('code' in response.data || 'message' in response.data) {
        throw new Error(
          (response.data.message as string) ||
            'Unknown error while fetching site from page-service'
        );
      }
      return response.data;
    },
  });
};

export const pageServiceSiteQueryDefaultParams = (): SiteParams => ({
  agent: import.meta.env.VITE_PORTAL,
  path: '/find',
  noOffers: true,
});

export const usePageServiceSite = (
  params: SiteParams = pageServiceSiteQueryDefaultParams()
) => {
  return useQuery(pageServiceSiteQuery(params));
};
